import React from 'react';
import { ACTIVE_THEME, getThemeVars } from '../themes/dashboardThemes';
import DashboardSidebar from '../components/DashboardSidebar';
import Prode from './Prode';

const ProdeNew = () => {
  const theme = getThemeVars(ACTIVE_THEME);

  return (
    <div
      className="dashboard-new font-body selection:bg-primary-container selection:text-on-primary-container h-screen overflow-hidden flex flex-col tablet-sm:flex-row"
      style={{ ...theme, backgroundColor: 'var(--chrome-bg)', color: 'var(--chrome-text)' }}
    >
      <DashboardSidebar activePath="/prode" />
      <main className="flex-1 h-screen overflow-hidden">
        <Prode />
      </main>
    </div>
  );
};

export default ProdeNew;
